export default {
  nome: {
    value: '',
    required: true,
    state: null
  },
  tipo: {
    value: null,
    options: [
      { value: 1, text: 'E-MAIL' },
      { value: 2, text: 'SMS' },
      { value: 3, text: 'WHATSAPP' }
    ],
    required: true,
    state: null
  },
  boardId: {
    value: null,
    options: []
  },
  boardColumnId: {
    value: null,
    options: []
  },
  origemId: {
    value: null,
    options: []
  },
  finalidade: {
    value: null,
    options: [
      { value: 1, text: 'CAMPANHA' },
      { value: 2, text: 'PESQUISA' },
      { value: 3, text: 'LISTA INTELIGENTE' },
      { value: 4, text: 'CRM' }
    ],
    required: true,
    state: null
  },
  urlRedirecionamento: {
    value: null,
    options: [],
    required: false
  },
  codigoCaptura: {
    value: null
  },
  template: {
    value: '',
    maxlength: '160',
    currentLength: 0,
    required: false,
    state: null,
    rows: 3,
    size: 500
  },
  tituloEmail: {
    value: '',
    required: false,
    state: null
  },
  msgSms: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/campaign/templates/components/add/campanhamodeloadd-form.js